export default {
  downloadApp: {
    title: "Download the app",
    body: "Take {{brand}} with you everywhere. Manage your appointments from the app and stay up to date wherever you are.",
    cancel: "Cancel",
    learnMore: "Learn more",
  },
  nav: {
    features: "Features",
    about: "About us",
    contact: "Contact",
    faqs: "FAQs",
    register: "Register",
    access: "Sign in",
  },
  hero: {
    title: "The all-in-one platform for healthcare professionals",
    subtitle:
      "Welcome to {{brand}}! A responsive, multi-device platform where everything is at your disposal—you choose what you use.",
    cta: "Reach us",
  },
  features: {
    title: "Features",
    appointments: {
      title: "Appointment Management",
      description:
        "Organize your schedule with ease. Automatic confirmations via WhatsApp.",
    },
    records: {
      title: "Digital Medical Records",
      description:
        "Access your patients' history anytime, anywhere.",
    },
    security: {
      title: "Privacy and Security",
      description:
        "We meet the highest standards to protect your data and your patients' data.",
    },
    extraTitle: "Additional features",
    extraItems: [
      "Notifications",
      "Share schedule (days/times) with institutions",
      "Insurance and private appointments",
      "Mercado Pago payments",
      "Patient reception",
      "Informed consent with templates to create your own",
      "ARCA invoicing",
      "Add secretaries (unlimited)",
      "Inventory: stock management, stockouts, alerts, supply costs, and more.",
      "Treatments",
      "And we keep adding more features…",
    ],
  },
  about: {
    eyebrow: "About us",
    title: "Who we are",
    philosophy: {
      title: "Our philosophy",
      body: "In medicine, nothing beats PERSONAL interaction—even when we offer you a digital solution. We are a family of doctors, developers, administrators, and patients who set out to offer tools with an unconventional cost-benefit ratio.",
    },
    approach: {
      title: "Our approach",
      body: "We are clear and direct about what we offer: you have everything and use what you want. No surprises, no overpaying. We communicate plainly, without reading between the lines, and we are here to help with whatever you need.",
    },
    commitment: {
      title: "Our commitment",
      body: "Professionals can run their practice smoothly, save time, and focus on diagnosis, treatment, follow-up, or any condition the patient presents through our omnichannel infrastructure. We value your time and our team's time. Our solution was built with modern technologies with a strong focus on UX and UI for professionals and patients.",
    },
    closing: "Thank you for your time—we hope to meet you soon!",
  },
  faqs: {
    eyebrow: "Frequently Asked Questions",
    title: "FAQs",
    moreQuestions: "Have more questions? Write to us!",
    contactUs: "Contact us",
    items: [
      {
        question: "Who is the platform for?",
        answer:
          "Independent physicians, physicians who work in multiple locations, small, medium, and large offices and polyclinics. Also institutions that want to outsource daily tasks that reduce productivity.",
      },
      {
        question: "If I'm not a doctor, can I register and use the platform with my Patients?",
        answer:
          "No. We validate each physician's license for every medical profile, ensuring professional credentials. We can recommend other apps if you are not a physician.",
      },
      {
        question: "Can I use some features or do I have to use all of them?",
        answer:
          "It's simple: you have everything and use what you want. You are not charged extra or less for using certain features.",
      },
      {
        question: "Is my data secure?",
        answer:
          "Always. Information is stored on state-of-the-art encrypted servers with ongoing updates. See our terms and conditions for more details.",
      },
      {
        question: "Do you offer support or help?",
        answer:
          "Of course! Our support channels are email, phone, or WhatsApp—whichever you prefer!",
      },
      {
        question: "What do I need to install or use the platform?",
        answer:
          "You can use or install it on your smartphone, tablet, or computer. All you need is internet access.",
      },
      {
        question: "Do I need training to set it up?",
        answer:
          "Not at all! The platform is very intuitive, easy to configure, and quick to set up. If you get stuck, our support channels are here to help.",
      },
      {
        question: "What is an Institution Profile?",
        answer:
          "A profile that can group several doctors and secretaries. It supports a structure where multiple professionals work with different schedules and assistants. The professional's schedule can be modified when shared, along with secretaries and institution contact info. We recommend this profile from practices with two or more doctors.",
        image: "/images/perfil-institucion-en.png",
        imageAlt: "Institution Profile",
      },
      {
        question: "Doctor profile description?",
        answer:
          "The most important profile—without it, you cannot use institutions, secretaries, and other features.",
        image: "/images/perfil-medico-en.png",
        imageAlt: "Doctor Profile",
      },
      {
        question: "Who gets charged?",
        answer:
          "Only the medical profile is charged. Other users do not pay to use the app or its features.",
      },
      {
        question: "What is the payment method?",
        answer: "Subscription via Mercado Pago.",
      },
      {
        question: "Do you offer free trial?",
        answer:
          "Yes! We offer 15 days free trial after you submit all the information and completed the subscription payment. It's automatic and you can cancel anytime. If you cancel and then return, you won't have 15 days trial.",
      },
      {
        question: "Which dollar rate is used?",
        answer:
          "For doctors in Argentina, the Banco Nación bill buy rate.\n\nFor doctors outside Argentina, according to the exchange rate to Argentine Pesos at their country's bank.",
      },
      {
        question: "We are a large clinic—do you offer discounts?",
        answer:
          "We evaluate these situations case by case, but we like to support you on your journey—reach out and you'll get good news.",
      },
    ],
  },
  contact: {
    eyebrow: "Get in touch",
    title: "Contact",
    cta: "Reach us",
  },
};
